import { render, staticRenderFns } from "./IQCqianhe.vue?vue&type=template&id=2466e843&scoped=true"
import script from "./IQCqianhe.vue?vue&type=script&lang=js"
export * from "./IQCqianhe.vue?vue&type=script&lang=js"
import style0 from "./IQCqianhe.vue?vue&type=style&index=0&id=2466e843&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2466e843",
  null
  
)

export default component.exports